const reCAPTCHAv3Action = {
  REGISTRATION: 'registration',
  REGISTRATION_STUDIO: 'registration_studio',
  LOGIN: 'login',
  LOGIN_STUDIO: 'login_studio',
};

export default reCAPTCHAv3Action;
